import { 
  collection, 
  getDocs, 
  query, 
  where, 
  orderBy 
} from 'firebase/firestore';
import { db } from '../lib/firebase';
import { ShopMessage } from '../types/shopMessage';

class ShopMessageService {
  private collectionName = 'shopMessages';

  // Aktív üzenetek lekérése webshop számára
  async getActiveMessagesForWebshop(organizationId: string, webshopId?: string): Promise<ShopMessage[]> {
    try {
      console.log('Querying Firebase for messages with organizationId:', organizationId);
      
      const q = query(
        collection(db, this.collectionName),
        where('organizationId', '==', organizationId),
        where('isActive', '==', true),
        orderBy('priority', 'desc'),
        orderBy('createdAt', 'desc')
      );

      const querySnapshot = await getDocs(q);
      console.log('Firebase query returned', querySnapshot.docs.length, 'documents');
      
      const messages: ShopMessage[] = [];
      const now = new Date();

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        
        // Dátum ellenőrzés
        const startDate = data.startDate ? data.startDate.toDate() : null;
        const endDate = data.endDate ? data.endDate.toDate() : null;
        
        const isInDateRange = (!startDate || startDate <= now) && (!endDate || endDate >= now);
        
        // Webshop szűrés
        const webshopIds = data.webshopIds || [];
        const isForWebshop = webshopIds.length === 0 || !webshopId || webshopIds.includes(webshopId);
        
        console.log('Processing message:', {
          id: doc.id,
          title: data.title,
          isInDateRange,
          isForWebshop,
          webshopIds: data.webshopIds
        });

        if (isInDateRange && isForWebshop) {
          messages.push({
            id: doc.id,
            organizationId: data.organizationId,
            title: data.title,
            content: data.content,
            type: data.type,
            priority: data.priority,
            isActive: data.isActive,
            startDate: startDate || undefined,
            endDate: endDate || undefined,
            webshopIds: data.webshopIds || [],
            backgroundColor: data.backgroundColor,
            textColor: data.textColor,
            link: data.link,
            showCloseButton: data.showCloseButton,
            showIcon: data.showIcon,
            position: data.position || 'top',
            createdAt: data.createdAt.toDate(),
            updatedAt: data.updatedAt.toDate(),
            createdBy: data.createdBy
          });
        }
      });

      console.log('Final filtered messages:', messages);
      return messages;
    } catch (error) {
      console.error('Error fetching active shop messages:', error);
      return [];
    }
  }
}

export const shopMessageService = new ShopMessageService();
